import { render, staticRenderFns } from "./HomeGame.vue?vue&type=template&id=0303623c&scoped=true&"
import script from "./HomeGame.vue?vue&type=script&lang=js&"
export * from "./HomeGame.vue?vue&type=script&lang=js&"
import style0 from "./HomeGame.vue?vue&type=style&index=0&id=0303623c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0303623c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0303623c')) {
      api.createRecord('0303623c', component.options)
    } else {
      api.reload('0303623c', component.options)
    }
    module.hot.accept("./HomeGame.vue?vue&type=template&id=0303623c&scoped=true&", function () {
      api.rerender('0303623c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeGame.vue"
export default component.exports